<p>{{text}}</p>
<p class="buttons">
  <button tuiButton type="button" [size]="tuiElementMediumSize" class="tui-space_right-3" (click)="submit(true)">Да</button>
  <button tuiButton type="button" [size]="tuiElementMediumSize" (click)="submit(false)">Нет</button>
</p>
